<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-lg-12">
				<div class="card">
					<div class="card-header">Все письма</div>
					<div class="card-body">
						<p>
						<button type="button" class="btn btn-primary" @click="created()"><i class="fa fa-plus"></i> СОЗДАТЬ РАССЫЛКУ</button>
						</p>
						<vuetable ref="vuetable"
							:fields="columns"
							:api-mode="false"
							:data="tableData"
							:css="css.table"
							@vuetable:row-dblclicked="editRow"
							@vuetable:pagination-data="onPaginationData">
						</vuetable>
						<vuetable-pagination ref="pagination"
						:css="css.pagination"
						@vuetable-pagination:change-page="onChangePage"
						></vuetable-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data () {
		return {
			columns: [
				{
					name: 'name',
					title: 'Наимеование'
				},
				{
					name: 'last_date_send_in_mailer',
					title: 'Дата отправки в рассылатель'
				},
				{
					name: 'id',
					title: 'ID'
				}
			],
			tableData: [],
			createdId: [],
			css: {
				table: {
					tableClass: 'table table-striped table-bordered table-hovered',
					ascendingIcon: 'glyphicon glyphicon-chevron-up',
					descendingIcon: 'glyphicon glyphicon-chevron-down',
					handleIcon: 'glyphicon glyphicon-menu-hamburger'
				},
				pagination: {
					infoClass: 'pull-left',
					wrapperClass: 'vuetable-pagination pull-right',
					activeClass: 'btn-primary',
					disabledClass: 'disabled',
					pageClass: 'btn btn-border',
					linkClass: 'btn btn-border',
					icons: {
						first: '',
						prev: '',
						next: '',
						last: ''
					}
				}
			}
		}
	},
	created () {
		this.getMailing()
	},
	methods: {
		getMailing (page = 1) {
			this.$store.commit('CALL_API_ON')
			this.$http.get(this.$store.state.apiURL + '/v1/mailings?page=' + page, {}, {
			}).then(function (response) {
				this.tableData = response.body
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		onPaginationData (paginationData) {
			this.$refs.pagination.setPaginationData(paginationData)
		},
		onChangePage (page) {
			this.getMailing(page)
			this.$refs.vuetable.changePage(page)
		},
		editRow (rowData) {
			window.location = document.location.href + '/create/' + JSON.stringify(rowData.id)
		},
		created () {
			this.$store.commit('CALL_API_ON')
			this.$http.post(this.$store.state.apiURL + '/v1/mailings', {}, {
			}).then(function (response) {
				this.createdId = response.body
				window.location = document.location.href + '/create/' + this.createdId
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/mailing/index.vue